<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 页面标题 -->
    <div class="bg-white shadow-sm border-b">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">总智能流</h1>
            <p class="text-sm text-gray-600">智能体工作流程总览 - Head-Agent 协调各专业智能体</p>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center space-x-2">
              <div class="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              <span class="text-sm text-gray-600">智能流运行中</span>
            </div>
            <button class="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors">
              <i class="fas fa-cog mr-2"></i>
              流程配置
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- Head-Agent 中央协调器 -->
      <div class="bg-gradient-to-r from-green-400 to-green-600 text-white rounded-lg p-6 mb-8 shadow-lg">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-xl font-bold">Head-Agent 中央协调器</h2>
          <div class="flex items-center space-x-2">
            <i class="fas fa-brain text-2xl"></i>
            <span class="text-sm opacity-90">智能协调中</span>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div class="bg-white bg-opacity-20 rounded-lg p-3">
            <div class="flex items-center mb-2">
              <i class="fas fa-lightbulb mr-2"></i>
              <span class="font-medium">意图识别</span>
            </div>
            <div class="text-xs opacity-90">理解用户需求</div>
          </div>
          <div class="bg-white bg-opacity-20 rounded-lg p-3">
            <div class="flex items-center mb-2">
              <i class="fas fa-sitemap mr-2"></i>
              <span class="font-medium">目标拆解</span>
            </div>
            <div class="text-xs opacity-90">分解复杂任务</div>
          </div>
          <div class="bg-white bg-opacity-20 rounded-lg p-3">
            <div class="flex items-center mb-2">
              <i class="fas fa-users-cog mr-2"></i>
              <span class="font-medium">Agent分解</span>
            </div>
            <div class="text-xs opacity-90">分配专业智能体</div>
          </div>
          <div class="bg-white bg-opacity-20 rounded-lg p-3">
            <div class="flex items-center mb-2">
              <i class="fas fa-share-alt mr-2"></i>
              <span class="font-medium">Agent分发</span>
            </div>
            <div class="text-xs opacity-90">任务分发执行</div>
          </div>
          <div class="bg-white bg-opacity-20 rounded-lg p-3">
            <div class="flex items-center mb-2">
              <i class="fas fa-chart-line mr-2"></i>
              <span class="font-medium">结果处理</span>
            </div>
            <div class="text-xs opacity-90">汇总处理结果</div>
          </div>
        </div>
      </div>

      <!-- 专业智能体工作流 -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <!-- Recruiting-Agent 招聘代理 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-user-plus mr-2 text-yellow-500"></i>
              Recruiting-Agent 招聘代理
            </h3>
            <span class="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">活跃</span>
          </div>
          <div class="space-y-3">
            <div class="flex items-center p-3 bg-yellow-50 rounded-lg">
              <div class="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">1</div>
              <div>
                <div class="font-medium text-gray-900">线索收集</div>
                <div class="text-xs text-gray-600">自动收集潜在创作者信息</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-yellow-50 rounded-lg">
              <div class="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">2</div>
              <div>
                <div class="font-medium text-gray-900">分析</div>
                <div class="text-xs text-gray-600">智能分析创作者潜力</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-yellow-50 rounded-lg">
              <div class="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">3</div>
              <div>
                <div class="font-medium text-gray-900">建联</div>
                <div class="text-xs text-gray-600">建立初步联系沟通</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-yellow-50 rounded-lg">
              <div class="w-8 h-8 bg-yellow-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">4</div>
              <div>
                <div class="font-medium text-gray-900">招聘合作</div>
                <div class="text-xs text-gray-600">达成合作意向</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Creator-Agent 创作者代理 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-user-tie mr-2 text-blue-500"></i>
              Creator-Agent 创作者代理
            </h3>
            <span class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">活跃</span>
          </div>
          <div class="space-y-3">
            <div class="flex items-center p-3 bg-blue-50 rounded-lg">
              <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">1</div>
              <div>
                <div class="font-medium text-gray-900">开播前受训</div>
                <div class="text-xs text-gray-600">专业培训提升技能</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-blue-50 rounded-lg">
              <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">2</div>
              <div>
                <div class="font-medium text-gray-900">直播话术</div>
                <div class="text-xs text-gray-600">智能生成直播脚本</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-blue-50 rounded-lg">
              <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">3</div>
              <div>
                <div class="font-medium text-gray-900">高光时刻</div>
                <div class="text-xs text-gray-600">自动识别精彩片段</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-blue-50 rounded-lg">
              <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">4</div>
              <div>
                <div class="font-medium text-gray-900">复盘改进</div>
                <div class="text-xs text-gray-600">数据分析优化建议</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-blue-50 rounded-lg">
              <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">5</div>
              <div>
                <div class="font-medium text-gray-900">收益汇总</div>
                <div class="text-xs text-gray-600">收入统计与分析</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Operation-Agent 运营代理 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-cogs mr-2 text-green-500"></i>
              Operation-Agent 运营代理
            </h3>
            <span class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">活跃</span>
          </div>
          <div class="space-y-3">
            <div class="flex items-center p-3 bg-green-50 rounded-lg">
              <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">1</div>
              <div>
                <div class="font-medium text-gray-900">开播前准备</div>
                <div class="text-xs text-gray-600">设备检查与场景布置</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-green-50 rounded-lg">
              <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">2</div>
              <div>
                <div class="font-medium text-gray-900">创作者培训</div>
                <div class="text-xs text-gray-600">专业技能培训指导</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-green-50 rounded-lg">
              <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">3</div>
              <div>
                <div class="font-medium text-gray-900">自动跟播</div>
                <div class="text-xs text-gray-600">智能跟播热门话题</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-green-50 rounded-lg border-l-4 border-green-500">
              <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">4</div>
              <div>
                <div class="font-medium text-gray-900">高光时刻</div>
                <div class="text-xs text-gray-600">AI识别精彩内容</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-green-50 rounded-lg border-l-4 border-green-500">
              <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">5</div>
              <div>
                <div class="font-medium text-gray-900">复盘</div>
                <div class="text-xs text-gray-600">深度数据分析</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-green-50 rounded-lg">
              <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">6</div>
              <div>
                <div class="font-medium text-gray-900">收益分析</div>
                <div class="text-xs text-gray-600">收入趋势与预测</div>
              </div>
            </div>
          </div>
        </div>

        <!-- VideoProducer-Agent 视频制作代理 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-video mr-2 text-purple-500"></i>
              VideoProducer-Agent 视频制作代理
            </h3>
            <span class="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">活跃</span>
          </div>
          <div class="space-y-3">
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">1</div>
              <div>
                <div class="font-medium text-gray-900">素材管理</div>
                <div class="text-xs text-gray-600">智能素材分类整理</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">2</div>
              <div>
                <div class="font-medium text-gray-900">内容主题</div>
                <div class="text-xs text-gray-600">AI生成内容主题</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">3</div>
              <div>
                <div class="font-medium text-gray-900">自动剪辑</div>
                <div class="text-xs text-gray-600">智能视频剪辑</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">4</div>
              <div>
                <div class="font-medium text-gray-900">自动生成</div>
                <div class="text-xs text-gray-600">AI生成视频内容</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">5</div>
              <div>
                <div class="font-medium text-gray-900">平台分发</div>
                <div class="text-xs text-gray-600">多平台智能分发</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">6</div>
              <div>
                <div class="font-medium text-gray-900">结果分析</div>
                <div class="text-xs text-gray-600">分发效果分析</div>
              </div>
            </div>
            <div class="flex items-center p-3 bg-purple-50 rounded-lg">
              <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-3">7</div>
              <div>
                <div class="font-medium text-gray-900">收益分析</div>
                <div class="text-xs text-gray-600">视频收益统计</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 智能流状态监控 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mt-8">
        <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-chart-line mr-2 text-purple-500"></i>
          智能流状态监控
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div class="text-center p-4 bg-gradient-to-r from-green-400 to-green-600 text-white rounded-lg">
            <div class="text-2xl font-bold">4</div>
            <div class="text-sm opacity-90">活跃智能体</div>
          </div>
          <div class="text-center p-4 bg-gradient-to-r from-blue-400 to-blue-600 text-white rounded-lg">
            <div class="text-2xl font-bold">156</div>
            <div class="text-sm opacity-90">今日处理任务</div>
          </div>
          <div class="text-center p-4 bg-gradient-to-r from-purple-400 to-purple-600 text-white rounded-lg">
            <div class="text-2xl font-bold">98.5%</div>
            <div class="text-sm opacity-90">任务成功率</div>
          </div>
          <div class="text-center p-4 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white rounded-lg">
            <div class="text-2xl font-bold">2.3s</div>
            <div class="text-sm opacity-90">平均响应时间</div>
          </div>
        </div>
      </div>

      <!-- 通信协议信息 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mt-8">
        <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <i class="fas fa-network-wired mr-2 text-gray-500"></i>
          通信协议
        </h3>
        <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <div class="w-3 h-3 bg-green-500 rounded-full"></div>
            <span class="text-sm text-gray-600">MCP协议</span>
          </div>
          <div class="flex items-center space-x-2">
            <div class="w-3 h-3 bg-blue-500 rounded-full"></div>
            <span class="text-sm text-gray-600">HTTP接口</span>
          </div>
          <div class="flex items-center space-x-2">
            <div class="w-3 h-3 bg-purple-500 rounded-full"></div>
            <span class="text-sm text-gray-600">实时通信</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeadFlow',
  data() {
    return {
      // 可以添加数据
    }
  },
  methods: {
    // 可以添加方法
  }
}
</script>

<style scoped>
/* 可以添加样式 */
</style> 